import React from "react";

const API_BASE =
  (import.meta?.env?.VITE_API_BASE) ||
  (process.env?.REACT_APP_API_BASE) ||
  "http://localhost:5000"; // fallback – produkcyjny backend

export default function AsyncOrderForm() {
  const [level, setLevel] = React.useState("podstawowy");
  const [variant, setVariant] = React.useState("z_wyjasnieniami");
  const [files, setFiles] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  function onPickFiles(e) {
    const picked = Array.from(e.target.files || []);
    setFiles(limitAndFilter(picked));
  }

  function onDrop(e) {
    e.preventDefault();
    const dropped = Array.from(e.dataTransfer.files || []);
    setFiles(limitAndFilter([...(files || []), ...dropped]));
  }

  function onDragOver(e) { e.preventDefault(); }

  function removeFile(idx) {
    setFiles((list) => list.filter((_, i) => i !== idx));
  }

  function limitAndFilter(arr) {
    const allowed = ["image/jpeg", "image/png", "image/webp", "image/gif", "application/pdf"]; 
    const filtered = arr.filter((f) => allowed.includes(f.type));
    return filtered.slice(0, 10);
  }

  async function jsonOrText(res) {
    const ct = res.headers.get("content-type") || "";
    if (ct.includes("application/json")) return res.json();
    const text = await res.text();
    throw new Error(`HTTP ${res.status}: ${text.slice(0, 300)}`);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const formData = new FormData(e.currentTarget);
      const name = formData.get("name");
      const email = formData.get("email");
      const phone = formData.get("phone");
      const description = formData.get("description");

      // 1) Upload do bufora na VPS
      const uploadFd = new FormData();
      for (const f of files) uploadFd.append("files", f);
      const upRes = await fetch(`${API_BASE}/api/uploads/temp`, { method: "POST", body: uploadFd });
      const { tempIds } = await jsonOrText(upRes);

      // 2) Utworzenie zamówienia + Checkout URL
      const orderRes = await fetch(`${API_BASE}/api/orders`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ level, variant, name, email, phone, description, tempIds }),
      });
      const orderData = await orderRes.json();
      if (!orderData?.checkoutUrl) throw new Error("Nie udało się utworzyć płatności");

      const url = orderData?.checkoutUrl;
        if (typeof url !== 'string' || !/^https?:\/\//.test(url)) {
          throw new Error(`Niepoprawny URL płatności: ${JSON.stringify(orderData).slice(0,200)}`);
        }

// użyj natywnego przejścia, nie React Router:
window.location.assign(url);

      // window.location.href = orderData.checkoutUrl;
    } catch (err) {
      console.error(err);
      setError(err.message || "Wystąpił błąd");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="form-card">
      <style>{`
        .form-card { background:#fff; border:1px solid #e5e7eb; border-radius:16px; padding:20px; box-shadow:0 2px 8px rgba(0,0,0,.04); max-width:820px; margin:0 auto; }
        .form-title { margin:0 0 8px; font-size:1.1rem; font-weight:600; }
        .form-note { margin:0 0 18px; color:#6b7280; font-size:0.92rem; }
        .grid { display:grid; gap:14px; }
        @media (min-width: 720px){ .grid-2 { grid-template-columns: 1fr 1fr; } }
        .field { display:flex; flex-direction:column; gap:6px; }
        .label { font-weight:600; font-size:0.95rem; }
        .input, .select, .textarea { border:1px solid #e5e7eb; border-radius:10px; padding:10px 12px; font-size:0.95rem; outline:none; transition:border-color .15s, box-shadow .15s; }
        .input:focus, .select:focus, .textarea:focus { border-color:#2563eb; box-shadow:0 0 0 3px rgba(37,99,235,.15); }
        .textarea { min-height:110px; resize:vertical; }
        .fieldset { border:1px solid #e5e7eb; border-radius:12px; padding:10px 12px; }
        .legend { font-weight:600; padding:0 6px; color:#374151; }
        .radio { display:flex; align-items:center; gap:8px; }
        .btn { display:inline-flex; align-items:center; justify-content:center; padding:12px 16px; border-radius:12px; border:0; background:#2563eb; color:#fff; font-weight:600; font-size:1rem; cursor:pointer; transition:transform .05s ease; }
        .btn:active { transform:translateY(1px); }
        .btn[disabled] { opacity:.6; cursor:not-allowed; }
        .error { background:#fef2f2; color:#991b1b; border:1px solid #fecaca; padding:10px 12px; border-radius:10px; margin-top:8px; }
        .drop { border:2px dashed #cbd5e1; border-radius:14px; padding:16px; text-align:center; color:#475569; background:#f8fafc; }
        .drop:hover { background:#f1f5f9; }
        .file-list { display:flex; flex-wrap:wrap; gap:8px; margin-top:10px; }
        .chip { display:flex; align-items:center; gap:8px; border:1px solid #e5e7eb; background:#fff; padding:6px 10px; border-radius:999px; font-size:0.9rem; }
        .chip button { border:0; background:transparent; cursor:pointer; font-weight:700; .variant { display: grid; gap: 10px; }
.option { display:flex; align-items:flex-start; gap:10px; border:1px solid #e5e7eb; border-radius:12px; padding:10px 12px; background:#fff; cursor:pointer; }
.option:hover { background:#f8fafc; border-color:#cbd5e1; }
.radio-input { width:18px; height:18px; accent-color:#2563eb; margin-top:2px; flex:0 0 auto; }
.option-text { font-weight:600; color:#1f2937; line-height:1.35;  }
      `}</style>

      <h4 className="form-title">Wyślij materiały i zapłać</h4>
      <p className="form-note">
        Materiały służą wyłącznie do nauki (sprawdzenie/wyjaśnienie rozwiązań). Nie przyjmujemy prac
        przeznaczonych na ocenę/egzamin.
      </p>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="grid grid-2">
          <div className="field">
            <label className="label" htmlFor="name">Imię i nazwisko</label>
            <input id="name" name="name" type="text" required className="input" />
          </div>
          <div className="field">
            <label className="label" htmlFor="email">Email</label>
            <input id="email" name="email" type="email" required className="input" />
          </div>
          <div className="field">
            <label className="label" htmlFor="phone">Telefon</label>
            <input id="phone" name="phone" type="tel" required className="input" />
          </div>
          <div className="field">
            <label className="label" htmlFor="level">Poziom</label>
            <select id="level" className="select" value={level} onChange={(e) => setLevel(e.target.value)}>
              <option value="podstawowy">Podstawowy</option>
              <option value="rozszerzony">Rozszerzony</option>
            </select>
          </div>
        </div>

        <div className="field" style={{ marginTop: 14 }}>
  <label className="label" htmlFor="variant">Wariant</label>
  <select
    id="variant"
    className="select"
    value={variant}
    onChange={(e) => setVariant(e.target.value)}
  >
    <option value="z_wyjasnieniami">Z wyjaśnieniami i pełnym omówieniem</option>
    <option value="bez_wyjasnien">Bez wyjaśnień (same odpowiedzi)</option>
  </select>
</div>



        <div className="field" style={{ marginTop: 14 }}>
          <label className="label" htmlFor="description">Opis (zakres, termin, uwagi)</label>
          <textarea id="description" name="description" className="textarea" rows={5} />
        </div>

        <div className="field" style={{ marginTop: 14 }}>
          <label className="label">Pliki (jpg/png/pdf, max 10)</label>
          <div className="drop" onDrop={onDrop} onDragOver={onDragOver}>
  <div>Przeciągnij i upuść tutaj pliki</div>
  <input
    id="fileInput"
    type="file"
    name="files"
    accept="image/*,application/pdf"
    multiple
    onChange={onPickFiles}
    style={{ display: "none" }}   // <- schowany input
  />
  <button
    type="button"
    className="btn"
    style={{ marginTop: 10 }}
    onClick={() => document.getElementById("fileInput")?.click()}
  >
    Wybierz pliki
  </button>
</div>

          {!!files.length && (
            <div className="file-list">
              {files.map((f, i) => (
                <span className="chip" key={`${f.name}-${i}`}>
                  {f.type.startsWith("image/") ? "🖼️" : "📄"} {f.name}
                  <button type="button" aria-label={`Usuń ${f.name}`} onClick={() => removeFile(i)}>×</button>
                </span>
              ))}
            </div>
          )}
        </div>

        {error && <div className="error">{error}</div>}

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
          <button className="btn" type="submit" disabled={loading}>
            {loading ? "Przetwarzanie…" : "Wyślij i zapłać"}
          </button>
        </div>
      </form>
    </div>
  );
}
